const SET_WELCOME_OFFER = (state, data) => {
  state.welcomeOffer = data
}

const SET_WORLD_CREDITS = (state, data) => {
  state.worldCredits = data
}

const SET_FETCH_SUBSCRIPTIONS_IN_PROGRESS = (state, data) => {
  state.states.getProducts.error = false
  state.states.getProducts.loading = true
  state.states.getProducts.msg = null
}

const SET_PRODUCTS = (state, data) => {
  state.subscriptions = data
  state.states.getProducts.loading = false
}

const SET_ERROR_FETCH_SUBSCRIPTIONS = (state, msg) => {
  state.states.getProducts.error = true
  state.states.getProducts.loading = false
  state.states.getProducts.msg = msg
}

const ADD_PRODUCT = (state, data) => {
  if (!state.subscriptions) {
    state.subscriptions = {}
  }
  state.subscriptions[data.productId] = data
}

const SET_DEAL_PRODUCTS = (state, data) => {
  state.deals = data
}

const ADD_DEAL = (state, data) => {
  let updatedDeals = {}
  updatedDeals[data.productId] = data
  state.deals = { ...state.deals, ...updatedDeals }
}

export default {
  SET_WELCOME_OFFER,
  SET_WORLD_CREDITS,
  SET_FETCH_SUBSCRIPTIONS_IN_PROGRESS,
  SET_PRODUCTS,
  SET_ERROR_FETCH_SUBSCRIPTIONS,
  ADD_PRODUCT,
  SET_DEAL_PRODUCTS,
  ADD_DEAL
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/products/mutations.js